import axios from "axios";

export function fetchTemplates(payload) {
  return new Promise((resolve, reject) => {
    axios.get(`/serialnumber/api/v1/product-ui-template?search=${payload.search}&page=${payload.page}&length=${payload.length}`,)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}
